import { useEffect } from 'react'
import {getSectionsByBookId, getSectionPartyFullsByBookId, getSectionsByPartyIdPartyMemberId, getSectionStructureType, getSectionClassList, getMessageTopics} from '../../../services/sBook/section.service'
import { isNullUndefined, treeify } from '../../../common/Helpers';
import { t } from 'i18next';

const useGetSectionsByBookId = (bookId, sectionArray, setSectionArray, setBookSectionList, makeTreeObject, selectInitialData = false, initialIdsDataArray = [], isPanelOpen, setSelectInitialData = null) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getSectionsByBookId(bookId);
    
                if (serviceResponse.data.succeeded) {
                    if (makeTreeObject !== undefined && makeTreeObject !== null) {
                        if (makeTreeObject) {
                            serviceResponse = treeify(serviceResponse !== null ? serviceResponse.data.data : [], 'id', null, 'children');

                            if (selectInitialData) {
                                serviceResponse.forEach(element => {
                                    initialIdsDataArray.forEach(id => {
                                        if (element.id === id) {
                                            element.checked = true;
                                        }
                                    });
                                });
                            }
                        }
                    }
                    
                    setSectionArray(serviceResponse);
                    setBookSectionList && setBookSectionList(serviceResponse);
                }
                else {
                    setSectionArray([]);
                    setBookSectionList && setBookSectionList([]);
                }
                setSelectInitialData && setSelectInitialData(false)
            }
            catch (error) {
                setSectionArray([]);
                setBookSectionList && setBookSectionList([]);
            }
        }
        
        if (bookId !== null && (sectionArray === null && isPanelOpen) && (selectInitialData === true ?  ((initialIdsDataArray !== null)? initialIdsDataArray.length > 0 : true) : true)) {
            getData()
        }

    }, [bookId, sectionArray, setBookSectionList, setSectionArray, selectInitialData, initialIdsDataArray, isPanelOpen, makeTreeObject, setSelectInitialData]);
}


const useGetMessageTopics = (topicList, setTopicList, isPanelOpen, topicIdToSelect = null) => {
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getMessageTopics();
    
                if (serviceResponse.data.succeeded) {

                    // se excluyen los topics ocultos (hidden), salvo el que ya tiene asignado el mensaje que se está editando
                    // (topicIdToSelect), que se sigue mostrando preseleccionado aunque ya no se pueda volver a elegir.
                    const l_data = (serviceResponse.data.data ?? []).filter(x => !x.hidden || x.id === topicIdToSelect);

                    serviceResponse = treeify(l_data, 'id', null, 'children');

                    serviceResponse.forEach(element => {
                        if (isNullUndefined(topicIdToSelect)) {
                            element.checked = false;
                        }
                        else {
                            element.checked = element.id === topicIdToSelect;
                        }
                    });

                    setTopicList && setTopicList(serviceResponse);
                }
                else {
                    setTopicList && setTopicList([]);
                }
            }
            catch (error) {
                setTopicList && setTopicList([]);
            }
        }
        
        if (topicList === null && isPanelOpen) {
            getData()
        }

    }, [topicList, setTopicList, isPanelOpen]);
}

const useGetSectionsByPartyId = (partyId, partyMemberId, sectionArray, setSectionArray, setBookSectionList, makeTreeObject, selectInitialData = false, initialIdsDataArray = [], isPanelOpen, setSelectInitialData = null, objFireGetSectionByParties) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                objFireGetSectionByParties.setFireGetSectionByParties(false)
                let serviceResponse = await getSectionsByPartyIdPartyMemberId(partyId, partyMemberId);
    
                if (serviceResponse.data.succeeded) {
                    if (makeTreeObject !== undefined && makeTreeObject !== null) {
                        if (makeTreeObject) {
                            serviceResponse = treeify(serviceResponse !== null ? serviceResponse.data.data : [], 'id', null, 'children');

                            if (selectInitialData) {
                                serviceResponse.forEach(element => {
                                    initialIdsDataArray.forEach(id => {
                                        if (element.id === id) {
                                            element.checked = true;
                                        }
                                    });
                                });
                            }
                        }
                    }
                    
                    setSectionArray(serviceResponse);
                    setBookSectionList && setBookSectionList(serviceResponse);
                }
                else {
                    setSectionArray([]);
                    setBookSectionList && setBookSectionList([]);
                }
                setSelectInitialData && setSelectInitialData(false)
            }
            catch (error) {
                setSectionArray([]);
                setBookSectionList && setBookSectionList([]);
            }
        }
        
        if (objFireGetSectionByParties.fireGetSectionByParties === true && partyId !== null && partyMemberId !== null && (sectionArray === null && isPanelOpen) && (selectInitialData === true ?  ((initialIdsDataArray !== null)? initialIdsDataArray.length > 0 : true) : true)) {
            getData()
        }

    }, [partyId, partyMemberId, sectionArray, setBookSectionList, setSectionArray, selectInitialData, initialIdsDataArray, isPanelOpen, makeTreeObject, setSelectInitialData, objFireGetSectionByParties]);
}

const useGetSectionsByBookId2 = (bookId, sectionArray, setSectionArray, setBookSectionList, makeTreeObject, selectInitialData = false, initialIdsDataArray = [], isPanelOpen, setSelectInitialData = null, forceUpdate, setForceUpdate) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getSectionsByBookId(bookId);
    
                if (serviceResponse.data.succeeded) {
                    if (makeTreeObject !== undefined && makeTreeObject !== null) {
                        if (makeTreeObject) {
                            serviceResponse = treeify(serviceResponse !== null ? serviceResponse.data.data : [], 'id', null, 'children');

                            if (selectInitialData) {
                                serviceResponse.forEach(element => {
                                    initialIdsDataArray.forEach(id => {
                                        if (element.id === id) {
                                            element.checked = true;
                                        }
                                    });
                                });
                            }

                            setForceUpdate && setForceUpdate(false)
                        }
                    }

                    setSectionArray(serviceResponse);
                    setBookSectionList && setBookSectionList(serviceResponse);
                }
                else {
                    setSectionArray([]);
                    setBookSectionList && setBookSectionList([]);
                }
                setSelectInitialData && setSelectInitialData(false)
            }
            catch (error) {
                setSectionArray([]);
                setBookSectionList && setBookSectionList([]);
            }
        }
        
        if (bookId !== null && ((sectionArray === null || forceUpdate) && isPanelOpen) && (selectInitialData === true ?  ((initialIdsDataArray !== null)? initialIdsDataArray.length > 0 : true) : true)) {
            getData()
        }

    }, [bookId, sectionArray, setBookSectionList, setSectionArray, selectInitialData, initialIdsDataArray, isPanelOpen, makeTreeObject, setSelectInitialData, forceUpdate, setForceUpdate]);
}

const useGetSectionPartyFullsByBookId = (bookId, sectionId, sectionArray, setSectionArray, setBookSectionList, fireEvent, setFireEvent, makeTreeObject, selectInitialData = false, initialIdsDataArray = []) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getSectionPartyFullsByBookId(bookId, sectionId);

                if (serviceResponse.data.succeeded) {
                    if (makeTreeObject !== undefined && makeTreeObject !== null) {
                        if (makeTreeObject) {
                            serviceResponse = treeify(serviceResponse !== null ? serviceResponse.data.data : [], 'id', null, 'children', 'partyName', 'sectionName');
    
                            if (selectInitialData) {
                                serviceResponse.forEach(element => {
                                    initialIdsDataArray.forEach(id => {
                                        if (element.id === id) {
                                            element.checked = true;
                                        }
                                    });
                                });
                            }
                        }
                    }
    
                    setSectionArray(serviceResponse);
                    setBookSectionList && setBookSectionList(serviceResponse);
                }
                else {
                    setSectionArray([]);
                    setBookSectionList && setBookSectionList([]);
                }

                setFireEvent(false)
            }
            catch (error) {
                setSectionArray([]);
                setBookSectionList && setBookSectionList([]);
                setFireEvent(false)
            }
        }
        
        if (bookId !== null && (sectionId !== null && sectionId !== undefined) && (fireEvent)) {
            getData()
        }
    }, [bookId, sectionId, sectionArray, setBookSectionList, fireEvent, setFireEvent, setSectionArray, selectInitialData, initialIdsDataArray, makeTreeObject]);
}

const useGetSectionStructureType = (bookId, sectionStructureType, setSectionStructureType, fireGet, setteretFireGet) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getSectionStructureType(bookId);

                if (serviceResponse.data.succeeded) {
                    const aux_result = []
                    serviceResponse.data.data.map(item => {
                        aux_result.push({ key: item.id, text:  item.name })
                    })

                    aux_result.unshift({ key: 0, text:  t('data-lang-lbl-select') })
                    setteretFireGet && setteretFireGet(false)
                    setSectionStructureType && setSectionStructureType(aux_result);
                }
                else {
                    setteretFireGet && setteretFireGet(false)
                    setSectionStructureType && setSectionStructureType([]);
                }
            }
            catch (error) {
                setteretFireGet && setteretFireGet(false)
                setSectionStructureType && setSectionStructureType([]);
            }
        }
        
        if (bookId !== null && bookId > 0 && (sectionStructureType === null || fireGet === true)) {
            getData()
        }
    }, [bookId, sectionStructureType, setSectionStructureType, fireGet, setteretFireGet]);
}

const useGetSectionClassList = (sectionClassList, setSectionClassList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getSectionClassList();

                if (serviceResponse.data.succeeded) {
                    const aux_result = []
                    serviceResponse.data.data.map(item => {
                        aux_result.push({ key: item.id, text:  item.name, milestoneCode: item.milestoneCode })
                    })

                    aux_result.unshift({ key: 0, text:  t('data-lang-lbl-select') })

                    setSectionClassList && setSectionClassList(aux_result);
                }
                else {
                    setSectionClassList && setSectionClassList([]);
                }
            }
            catch (error) {
                setSectionClassList && setSectionClassList([]);
            }
        }
        
        if (sectionClassList === null) {
            getData()
        }
    }, [sectionClassList, setSectionClassList]);
}

export {
    useGetSectionsByBookId,
    useGetMessageTopics,
    useGetSectionsByPartyId,
    useGetSectionsByBookId2,
    useGetSectionPartyFullsByBookId,
    useGetSectionStructureType,
    useGetSectionClassList
}